import { styled } from 'styled-components';

import { RadioButtons } from '#/components/Radio/RadioButtons';
import { useI18n } from '#/i18n/hooks/useI18n';
import { useSearchSort } from '#/modules/search/contexts/SearchContext';
import type { SearchSortType } from '#/modules/search/types/SearchSortType';
import { colors, fontSizes, spacing } from '#/theme/theme';

const SortSectionHolder = styled.fieldset`
  border: none;
  margin: 0;
  padding: 0 0 ${spacing[16]} 0;
  border-bottom: 1px solid ${colors.elementGrey};
`;

const SortSectionLegend = styled.legend`
  font-size: ${fontSizes[16]};
  font-weight: 600;
  color: ${colors.darkContentGrey};
  padding: 0;
  margin-bottom: ${spacing[12]};
`;

type Props = {
  onChangeSort: (sort: SearchSortType) => void;
};

export function MobileSearchFilterSortSection({ onChangeSort }: Props) {
  const { i18n } = useI18n();
  const currentSort = useSearchSort();

  return (
    <SortSectionHolder>
      <SortSectionLegend>{i18n('Sort By')}</SortSectionLegend>
      <RadioButtons
        qaId="mobile-filter-sort"
        name="mobile-sort"
        value={currentSort}
        large
        columns={2}
        buttons={[
          { label: i18n('Best Match'), value: 'relevance' },
          { label: i18n('Newest'), value: 'newest' },
        ]}
        onChange={(value) => onChangeSort(value as SearchSortType)}
      />
    </SortSectionHolder>
  );
}
